
// Reliable online csv to json converter (free)
// http://www.convertcsv.com/csv-to-json.htm
// Others
// http://www.cparker15.com/code/utilities/csv-to-json/
//http://www.zenovations.com/misc/convertcsv/

/* old
	var prostate_data2 = [
	  {
	    "Disease":"http://snomed.info/sct/420120006",
	    "Race":"Other",
	    "Dx-Year":2004,
	    "Dx-Age":"45-49 years",
	    "Is-Alive":"Alive",
	    "Survival-months":78,
	    "Dx-Grade":"Grade II",
	    "Treatment":"surgery+rad",
	    "Urinary-Dys":"no",
	    "Bowel-Dys":"yes",
	    "Hot-Flash":"no",
	    "Dec-Libido":"yes",
	    "N/V":"no",
	    "Weight-Loss":"no",
	    "Fatigue":"yes",
	    "Anemia":"no",
	    "Erectile-Dys":"no",
	    "Radiation":"no",
	    "Surg+Rad":"yes",
	    "Surgery":"no",
	    "Hormonal":"no",
	    "Chemo":"no",
	    "Chemo+Rad":"no",
	    "No-Treatment":"no"
	  },
//*/

var treatmentData =
[
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":42,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":9,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":20,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":26,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":39,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":3,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":44,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":22,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":51,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":6,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":12,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":2,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":16,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":9,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":54,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":32,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":17,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Dead",
        "Survival-months":46,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":34,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":44,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":48,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":54,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":41,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":42,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":6,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":45,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":10,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":35,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":33,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":7,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade I",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":4,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":14,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Dead",
        "Survival-months":33,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other unspecified (1991+)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade IV",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":46,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":50,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":48,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":22,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":54,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":21,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":29,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":52,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":31,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":40,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":11,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Dead",
        "Survival-months":6,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":27,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":24,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":41,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":29,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":13,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":13,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":48,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":21,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":25,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":15,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":45,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":32,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":25,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":13,
        "Dx-Grade":"Grade IV",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":29,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":40,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade I",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":42,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":20,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":47,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Dead",
        "Survival-months":46,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":33,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":45,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":57,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":18,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":30,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade I",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":5,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other unspecified (1991+)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":3,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":28,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":8,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":23,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":18,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":16,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":2,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":41,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other unspecified (1991+)",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade I",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":56,
        "Dx-Grade":"Grade IV",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":51,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":54,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":13,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Dead",
        "Survival-months":6,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":12,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":19,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":53,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":45,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":21,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":24,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":7,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":33,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":49,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":26,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":6,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":26,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":52,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":28,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":51,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":37,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":25,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":58,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Dead",
        "Survival-months":29,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":7,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":20,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":35,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":52,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":42,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":15,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Dead",
        "Survival-months":34,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":58,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":21,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":37,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":56,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":55,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":11,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":25,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":50,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other unspecified (1991+)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":18,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":21,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":35,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"45-49 years",
        "Is-Alive":"Dead",
        "Survival-months":17,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":8,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":3,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":56,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"40-44 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":58,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":45,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":57,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":28,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":18,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":23,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Dead",
        "Survival-months":46,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":44,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Dead",
        "Survival-months":8,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":29,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":7,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Unknown",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":0,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":45,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":20,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Black",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":30,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Dead",
        "Survival-months":14,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":42,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":67,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":59,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Dead",
        "Survival-months":48,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":71,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"yes",
        "Urinary-Dys":"yes",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"No-Treatment"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":16,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":69,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Dead",
        "Survival-months":14,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"yes",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"yes",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":63,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":64,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"75-79 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"85+ years",
        "Is-Alive":"Alive",
        "Survival-months":66,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":65,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"yes",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade II",
        "Chemo":"yes",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"yes",
        "Erectile-Dys":"no",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":60,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"50-54 years",
        "Is-Alive":"Alive",
        "Survival-months":7,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"yes",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"60-64 years",
        "Is-Alive":"Alive",
        "Survival-months":68,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"Other (American Indian/AK Native; Asian/Pacific Islander)",
        "Dx-Year":2004,
        "Dx-Age":"55-59 years",
        "Is-Alive":"Alive",
        "Survival-months":70,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Dead",
        "Survival-months":35,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"no",
        "Anemia":"yes",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"70-74 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"no",
        "Chemo+Rad":"no",
        "Surg+Rad":"yes",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"yes",
        "N/V":"no",
        "Weight-Loss":"yes",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"no",
        "Treat-option":"Surg+TKI"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"65-69 years",
        "Is-Alive":"Alive",
        "Survival-months":62,
        "Dx-Grade":"Grade II",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"yes",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"no",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    },
    {
        "Disease":"http://snomed.info/sct/420120006",
        "Race":"White",
        "Dx-Year":2004,
        "Dx-Age":"80-84 years",
        "Is-Alive":"Alive",
        "Survival-months":61,
        "Dx-Grade":"Grade III",
        "Chemo":"no",
        "Radiation":"no",
        "Hormonal":"no",
        "Surgery":"yes",
        "Chemo+Rad":"no",
        "Surg+Rad":"no",
        "No-Treatment":"no",
        "Urinary-Dys":"no",
        "Bowel-Dys":"no",
        "Hot-Flash":"no",
        "Dec-Libido":"no",
        "N/V":"yes",
        "Weight-Loss":"no",
        "Fatigue":"yes",
        "Anemia":"no",
        "Erectile-Dys":"yes",
        "Treat-option":"Surgery"
    }
];

/*
var treatmentData_v1 = [
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "311",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "1",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Miscellaneous Malignant Cancer",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Miscellaneous Malignant Cancer",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Cerebrovascular Diseases",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Cerebrovascular Diseases",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8120",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "436",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "19",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Chronic Liver Disease and Cirrhosis",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Chronic Liver Disease and Cirrhosis",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "56",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "409",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1975",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "16",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Suicide and Self-Inflicted Injury",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Suicide and Self-Inflicted Injury",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "44",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "380",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "14",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "42",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Miscellaneous Malignant Cancer",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Miscellaneous Malignant Cancer",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "402",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Radiation, NOS  method or source not specified",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "130",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "34",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "177",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "21",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "242",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "390",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "19",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Urinary Bladder",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Urinary Bladder",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "292",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "89",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Pancreas",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Pancreas",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "165",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "373",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1978",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "374",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1978",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "19",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "325",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Pneumonia and Influenza",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Pneumonia and Influenza",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8130",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "372",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1978",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "40",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "79",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "12",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "281",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1979",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "348",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "12",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "21",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8000",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "144",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diabetes Mellitus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diabetes Mellitus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "34",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "72",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended, unknown if performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "3",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1979",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "6",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "170",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "45",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "358",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1980",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8550",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "193",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1980",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "20",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "72",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "47",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1980",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "91",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1981",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "38",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1981",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "341",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1981",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "16",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1981",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "77",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1981",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "340",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1981",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "342",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1981",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "174",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1981",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8550",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "33",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "86",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "195",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Recommended, unknown if administered",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "68",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "20",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1982",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Accidents and Adverse Effects",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Accidents and Adverse Effects",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "259",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "323",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1983",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "62",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "319",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1983",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Other Lymphocytic Leukemia",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Other Lymphocytic Leukemia",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "323",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1983",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "37",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "54",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1983",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8260",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "319",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1983",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "304",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1984",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "292",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1984",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "20",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1984",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Salivary Gland",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Salivary Gland",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1984",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "307",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1984",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "82",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1984",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "5",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Colon excluding Rectum",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Colon excluding Rectum",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1984",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "306",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1984",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "292",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "40",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "292",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Combination of beam with implants or isotopes",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "291",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "298",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "28",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "13",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "294",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "296",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "22",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "79",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "295",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "34",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1985",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "293",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1985",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "214",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "14",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended, unknown if performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "229",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Pancreas",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Pancreas",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "38",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Pneumonia and Influenza",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Pneumonia and Influenza",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "276",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1986",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "283",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1986",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "276",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1986",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "285",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1986",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "13",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "236",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1986",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1986",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "70",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Unknown",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "267",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1987",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "55",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Urinary Bladder",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Urinary Bladder",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "12",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "2",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "34",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "270",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1987",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "168",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1987",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "2",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "256",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "25",
		"EOD 10 - extent (1988-2003)": "40",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "248",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "256",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "55",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "40",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "48",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "9",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "1",
		"EOD 10 - extent (1988-2003)": "85",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "10",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "80",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "9",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "17",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "5",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "43",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "13",
		"EOD 10 - extent (1988-2003)": "40",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "254",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "15",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, patient refused",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "262",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "10",
		"EOD 10 - extent (1988-2003)": "20",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "258",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "252",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "262",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1988",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "6",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended, unknown if performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "37",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1988",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "246",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "85",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "29",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1989",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "30",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "246",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "45",
		"EOD 10 - extent (1988-2003)": "50",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "86",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1989",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "25",
		"EOD 10 - extent (1988-2003)": "20",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "250",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "241",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "32",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1989",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "70",
		"EOD 10 - nodes (1988-2003)": "2",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "240",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "244",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "99",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "251",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1989",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "85",
		"EOD 10 - nodes (1988-2003)": "9",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, patient refused",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "6",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1989",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "20",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "232",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1990",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "85",
		"EOD 10 - nodes (1988-2003)": "6",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "15",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1990",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "40-44 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "999",
		"EOD 10 - extent (1988-2003)": "20",
		"EOD 10 - nodes (1988-2003)": "0",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "238",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1990",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "434",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1973",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Chronic Liver Disease and Cirrhosis",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Liver Disease and Cirrhosis",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Chronic Liver Disease and Cirrhosis",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Liver Disease and Cirrhosis",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "313",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Chronic Liver Disease and Cirrhosis",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Liver Disease and Cirrhosis",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8020",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "83",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Miscellaneous Malignant Cancer",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Miscellaneous Malignant Cancer",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "162",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "137",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "106",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "199",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "9",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Aortic Aneurysm and Dissection",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Aortic Aneurysm and Dissection",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8041",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "18",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "52",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "391",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "17",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "65",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "150",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "183",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8500",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "343",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Accidents and Adverse Effects",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Accidents and Adverse Effects",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "18",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "2",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1973",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "146",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "280",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "152",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "159",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "13",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "64",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "227",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "347",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "407",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "326",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "116",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "51",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "95",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Cerebrovascular Diseases",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Cerebrovascular Diseases",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "42",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "195",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "23",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "37",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Unknown",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "238",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diabetes Mellitus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diabetes Mellitus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "126",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "112",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "292",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Acute Myeloid Leukemia",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Acute Myeloid Leukemia",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "30",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "431",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Esophagus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Esophagus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "25",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "10",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "222",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1974",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "182",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Cerebrovascular Diseases",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Cerebrovascular Diseases",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "16",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "61",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "341",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "2",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "30",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "167",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "293",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "10",
		"Type of follow-up expected": "SF/Oakland only (originally inactive/now active)",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "45",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "389",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8020",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "25",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "264",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "93",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "297",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "110",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "130",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "23",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "358",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "376",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "28",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "266",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Accidents and Adverse Effects",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Accidents and Adverse Effects",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "414",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "24",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Nephritis, Nephrotic Syndrome and Nephrosis",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Nephritis, Nephrotic Syndrome and Nephrosis",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "18",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "47",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Digestive Organs",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Other Digestive Organs",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "24",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "39",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Cerebrovascular Diseases",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Cerebrovascular Diseases",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "18",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Other Infectious and Parasitic Diseases including HIV",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Other Infectious and Parasitic Diseases including HIV",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "100",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1975",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "100",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Suicide and Self-Inflicted Injury",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Suicide and Self-Inflicted Injury",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "25",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "26",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "268",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "56",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "94",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "75",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "26",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Chronic Myeloid Leukemia",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Chronic Myeloid Leukemia",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "101",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Septicemia",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Septicemia",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "98",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "State DC not available or state DC available but no COD",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "State DC not available or state DC available but no COD",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "10",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "19",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8120",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "383",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "127",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "In situ, benign or unknown behavior neoplasm",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "In situ, benign or unknown behavior neoplasm",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "281",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Aortic Aneurysm and Dissection",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Aortic Aneurysm and Dissection",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "40",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "37",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Homicide and Legal Intervention",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Homicide and Legal Intervention",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Unknown",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "201",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "26",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1976",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "171",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "286",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "N/A not first tumor",
		"Survival time recode (total # of months)": "407",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "N/A not first tumor",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "41",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "155",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Pneumonia and Influenza",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Pneumonia and Influenza",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "352",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Chronic Obstructive Pulmonary Disease and Allied Cond",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "18",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "36",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "13",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "78",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1976",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "35",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "123",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "295",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Miscellaneous Malignant Cancer",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Miscellaneous Malignant Cancer",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Other radiation (1973-1987 cases only)",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "273",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Colon excluding Rectum",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Colon excluding Rectum",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Unknown",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "2",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "392",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1977",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "35",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Brain and Other Nervous System",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Brain and Other Nervous System",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "39",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "35",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "15",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Connecticut - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Unknown; death certificate or autopsy only case",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "259",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "7",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Rectum and Rectosigmoid Junction",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Rectum and Rectosigmoid Junction",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "64",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Utah - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "395",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "19",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "157",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Atlanta (Metropolitan) - 1975+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "2",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Undifferentiated; anaplastic; Grade IV"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "393",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "Hawaii - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Not recommended, contraindicated due to other conditions",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "0",
		"Type of follow-up expected": "Autopsy/death certificate only cases",
		"COD to site recode": "Cerebrovascular Diseases",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Cerebrovascular Diseases",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "284",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8010",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "3",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Recommended, unknown if administered",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "17",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Black",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "4",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Unknown"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Detroit (Metropolitan) - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "322",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Other Cause of Death",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Other Cause of Death",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1977",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "373",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "375",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Alive",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Alive",
		"Vital status recode (study cutoff used)": "Alive",
		"Year of diagnosis": "1978",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "52",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "132",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Urinary Bladder",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Urinary Bladder",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Seattle (Puget Sound) - 1974+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "33",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "Iowa - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "316",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Poorly differentiated; Grade III"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "Beam radiation",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "251",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Diseases of Heart",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Diseases of Heart",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "Other (American Indian/AK Native, Asian/Pacific Islander)",
		"TREATMENT DATA registry": "New Mexico - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "20",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Recommended but not performed, unknown reason",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Dead",
		"Survival time recode (total # of months)": "11",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Prostate",
		"TREATMENT DATA other cause of death classification": "Alive or dead due to cancer",
		"COD to site rec KM": "Prostate",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Moderately differentiated; Grade II"
	},
	{
		"Age recode with <1 year olds": "45-49 years",
		"Sex": "Male",
		"CS Schema v0203": "Prostate",
		"Race recode (White, Black, Other)": "White",
		"TREATMENT DATA registry": "San Francisco-Oakland SMSA - 1973+",
		"Primary Site": "619",
		"Histologic Type ICD-O-3": "8140",
		"Behavior code ICD-O-3 (1973+)": "Malignant",
		"EOD 10 - size (1988-2003)": "Blank(s)",
		"EOD 10 - extent (1988-2003)": "Blank(s)",
		"EOD 10 - nodes (1988-2003)": "Blank(s)",
		"EOD 10 - Prostate path ext (1995-2003)": "Blank(s)",
		"RX Summ--Surg Prim Site (1998+)": "Blank(s)",
		"Reason no cancer-directed surgery": "Surgery performed",
		"Radiation": "None",
		"TREATMENT DATA cause-specific death classification": "Alive or dead of other cause",
		"Survival time recode (total # of months)": "209",
		"Type of follow-up expected": "Active follow-up",
		"COD to site recode": "Lung and Bronchus",
		"TREATMENT DATA other cause of death classification": "Dead",
		"COD to site rec KM": "Lung and Bronchus",
		"Vital status recode (study cutoff used)": "Dead",
		"Year of diagnosis": "1978",
		"Grade": "Well differentiated; Grade I"
	}
]
*/

export {treatmentData};